export function target() {
  return (
    ['Menu', 'Footer', 'BannerWithMenu'].includes(this.module) &&
    typeof this.data.logoImg === 'undefined'
  );
}

export function migrate(settingsInstance) {
  const { hotelName, logo, logoLinkCheckbox, logoLink } = settingsInstance;

  if (this.module === 'Footer') {
    this.data.hotelName = hotelName;
  }
  this.data.logoAltText = hotelName;
  this.data.logoImg = logo;
  this.data.hasLogoLink = logoLinkCheckbox;
  this.data.logoUrl = logoLink;
}
